import { h } from "preact";
import { useState } from "preact/hooks";
import { FilePickerAcceptType, FilePickerContainer, NativeDirectoryHandle } from "./DynamicFile";
import { useCommandHandler } from "../hooks";
import { Command } from "../hooks/Command";

export function DynamicDirectoryInput(props: { onChange: (data: NativeDirectoryHandle | null) => void, allowReload?: boolean, allowClear?: boolean, displayName?: boolean, doClear?: Command, types?: FilePickerAcceptType[] }) {
    const [handle, setHandle] = useState(null as NativeDirectoryHandle | null);

    useCommandHandler(props.doClear, () => {
        props.onChange(null);
    }); //, [true]);

    return <div>
        <button type="button" onClick={async (e) => {
            const ww = window as unknown as FilePickerContainer;
            let directory;

            try {
                directory = await ww.showDirectoryPicker();
            }
            catch(ex) {
                if (ex instanceof Error && "AbortError" !== ex.name) {
                    console.error(ex);
                }

                props.onChange(null);
                setHandle(null);
                return;
            }

            props.onChange(directory);
            setHandle(directory);
        }}>Otwórz folder</button>
        {props.allowReload !== false ? <button type="button" class={handle ? "" : "disabled"} style="margin-left: 10px;" onClick={async () => {
            if (!handle) {
                props.onChange(null);
                setHandle(null);
                return;
            }

            setHandle(handle);
            props.onChange(handle);
        }}>Przeładuj</button> : null}
        {props.allowClear !== false ? <button type="button" class={"error" + (handle ? "" : " disabled")} style="margin-left: 10px; margin-right: 10px;" onClick={async () => {
            setHandle(null);
            props.onChange(null);
        }}>Wyczyść</button> : null}
        {props.displayName !== false ? <div style="margin-left: 10px; margin-bottom: 10px;">{handle ? handle.name : ""}</div> : null}
    </div>;
}
